import { createAction } from '@reduxjs/toolkit';
import giftCardsSlice from './slice';

export const fetchWithdrawalStatus = createAction('giftCards/fetchWithdrawalStatus');
export const fetchCategories = createAction('giftCards/fetchCategories');
export const fetchGiftCards = createAction('giftCards/fetchGiftCards');

export const {
  receiveGiftCards,
  addGiftCards,
  receivePopularGiftCards,
  addPopularGiftCards,
  receiveCategories,
  selectCategories,
  setValue,
  reset,
} = giftCardsSlice.actions;
